export enum HTTPS_METHOD { POST, DELETE, GET, PUT, PATCH};

export class SyncableTask<T = object> {
  constructor(
    public method: HTTPS_METHOD,
    public url: string,
    public body?: T) { }
}

